import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_post_hdr_RowClass} from '../../../dbschema/bl_cms_post_hdr.model';

export class CmsPostHeaderContainerModel extends BaseContainerModel {
  bl_cms_post_hdr: bl_cms_post_hdr_RowClass = new bl_cms_post_hdr_RowClass();
}
